import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectModelIdsByIriSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      diagramSnapshotSelector(projectId),
      (project, diagram) =>
        project && diagram
          ? Object.fromEntries(
              Object.entries(diagram.model.modelData.modelsByIri).filter(
                ([id]) => !diagram.model.modelData.deletedModelIds?.includes(id)
              )
            )
          : {}
    )
);
